const state = {
  ResponseData: null,
  Nutrients: [],
  FertilizerRecommendations: [],
  Recommendations: [],
  ErrorSubmit: false
};

const getters = {
  responseData: state => {
    return state.ResponseData;
  },
  nutrients: state => {
    return state.Nutrients;
  },
  fertilizerRecommendations: state => {
    return state.FertilizerRecommendations;
  },
  recommendations: state => {
    return state.Recommendations;
  },
  errorSubmit: state => {
    return state.ErrorSubmit;
  }
};

const mutations = {
  UpdateResponseData: (state, payload) => {
    state.ResponseData = payload;
  },
  UpdateNutrients: (state, payload) => {
    state.Nutrients = payload;
  },
  UpdateFertilizerRecommendations: (state, payload) => {
    state.FertilizerRecommendations = payload;
  },
  UpdateRecommendations: (state, payload) => {
    state.Recommendations = payload;
  },
  UpdateErrorSubmit: (state, payload) => {
    state.ErrorSubmit = payload;
  }
};

const actions = {
  UpdateResponseData ({ commit }, payload) {
    commit('UpdateResponseData', payload);
  },
  UpdateNutrients ({ commit }, payload) {
    commit('UpdateNutrients', payload);
  },
  UpdateFertilizerRecommendations ({ commit }, payload) {
    commit('UpdateFertilizerRecommendations', payload);
  },
  UpdateRecommendations ({ commit }, payload) {
    commit('UpdateRecommendations', payload);
  },
  UpdateErrorSubmit ({ commit }, payload) {
    commit('UpdateErrorSubmit', payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
